@if (error && error.length > 0) {
  <p>error</p>
}
@if (had_file) {
  <div style="display: flex; flex-direction: column">
    @if (required_configurations.length > 0) {
      <h2>Required configurations</h2>
      <div class="row auto required-configurations">
        <ul>
          @for (c of required_configurations; track c) {
            <li>{{c}}</li>
          }
        </ul>
      </div>
    }
    <h2 style="margin-bottom:0;">Upload options</h2>
    <div class="row medium-height center">
      <mat-checkbox [ngModel]="displayOptions.update_only" (change)="setUpdateOnly($event.checked)"
        [disabled]="readonly"
        name="update_only"
                    title="Select to exclude Events which do
                         not yet exist in WIRE">Update Only
      </mat-checkbox>
    </div>
    <div class="row">
      <event-model-upload-select-event-type class="select-search" (eventTypeIDChange)="setEventType($event)"
        [readonly]="readonly">
      </event-model-upload-select-event-type>
      <mat-form-field>
        <mat-label>Select upsert type</mat-label>
        <mat-select [ngModel]="displayOptions.upsert_type" (selectionChange)="setUpsertType($event.value)"
          [disabled]="readonly">
          @for (upsert_type of upsert_types; track upsert_type) {
            <mat-option
              [value]="upsert_type.value"
              [disabled]="upsert_type.disabled">
              {{upsert_type.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field title="Trim this number of rows from the top of the csv file.">
        <mat-label>Skip Rows</mat-label>
        <input (ngModelChange)="setSkipRows($event)"
          [min]="0"
          [ngModelOptions]="{standalone: true}" [ngModel]="displayOptions.skip_rows"
          [disabled]="readonly"
          matInput
          type="number">
      </mat-form-field>
      <mat-checkbox class="self-center"
        (change)="setUseColumnIndexes($event.checked)"
        [checked]="displayOptions.use_column_indexes"
        [disabled]="readonly"
        title="Named columns expect header names in first row.&#013;Index headers expect data in the first row.">
        Use column indexes for header names
      </mat-checkbox>
    </div>
    <!-- Select unique property for upsert -->
    @if (displayOptions.upsert_type == 'unique_property') {
      <event-model-upload-select-unique-property
        style="width: 100%"
        [readonly]="readonly"
        (constantPropertyIDChange)="setUniqueProperty($event)"
      ></event-model-upload-select-unique-property>
    }
    <h2>Header associations</h2>
    <div class="row auto">
      <h4 style="flex: 1">Column Headers</h4>
      <h4 style="flex: 2">Parser Feature</h4>
      <h4 style="flex: 2">Assign Type</h4>
    </div>
    @for (header of header_associations; track header) {
      <div class="row medium-height">
        <div [title]="header.source" class="column-header">
          {{header.source}}
        </div>
        <div class="row  medium-height" style="flex: 2">
          <mat-form-field class="no-label">
            <mat-select [ngModel]="header.target_type" (selectionChange)="setHeaderTarget(header, $event)"
              [disabled]="readonly">
              @for (option of model_upload_features; track option) {
                <mat-option [value]="option">
                  {{DESCRIPTIONS[option]}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="row medium-height" style="flex: 2">
          <!-- Components -->
          @if (header.target_type == HEADER_TYPES.COMPONENT) {
            <event-model-upload-select-component
              class="full-width full-height"
              [componentTypeID]="header.override_id"
              (componentTypeIDChange)="setOverride(header, $event)"
            ></event-model-upload-select-component>
          }
          <!-- Constant Properties -->
          @if (header.target_type == HEADER_TYPES.PROPERTY) {
            <event-model-upload-select-constant-property
              class="full-width full-height"
              [readonly]="readonly"
              [constantPropertyID]="header.override_id"
              (constantPropertyIDChange)="setOverride(header, $event)"
            ></event-model-upload-select-constant-property>
          }
        </div>
      </div>
    }
  </div>
} @else {
  <p>Please select a file to upload.</p>
}
